<template>
    <DropdownMenu>
        <HeaderMenuTrigger> API </HeaderMenuTrigger>
        <DropdownMenuContent>
            <DropdownMenuItem v-for="link in apiLinks" :key="link.to" as-child>
                <NuxtLink :to="localePath(link.to)">
                    {{ link.title }}
                </NuxtLink>
            </DropdownMenuItem>
        </DropdownMenuContent>
    </DropdownMenu>
</template>

<script setup lang="ts">
const localePath = useLocalePath();

const apiLinks = [
    { title: "Inventory API", to: "/docs/api" },
    { title: "Inventory AI Agent Service", to: "/docs/ai-agents" },
];
</script>
